// extracted by mini-css-extract-plugin
export default {"backToHome":"BackToHome_backToHome__knu-h"};